/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { IAwardPeriodDataState } from "Interfaces/SiteContent/IAwardPeriodDataState";
import { IAwardPeriodOption } from "Interfaces/SiteContent/IAwardPeriodOption";

/**
 * Returns the award period option list.
 * @param awardPeriodState
 */
export const getAwardPeriodOptionList = (
  awardPeriodState: IAwardPeriodDataState
): IAwardPeriodOption[] => awardPeriodState.awardPeriodOptionList;
